var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "play_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#play_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.669 23.465V9.58c0-.317.106-.573.317-.766a1.06 1.06 0 01.74-.291c.091 0 .185.012.28.037.095.025.188.062.28.11l10.927 6.965c.162.113.284.243.365.391.08.148.121.314.121.497s-.04.349-.121.497a1.158 1.158 0 01-.365.39l-10.927 6.965c-.092.05-.185.086-.28.111a1.116 1.116 0 01-.28.037 1.06 1.06 0 01-.74-.29c-.211-.194-.317-.45-.317-.767z",
    fill: "#fff"
  }))));
}
export default SvgPlay;